import { API_PREFIX_SUPPLIERS_PATH } from "@/constants/prefix-path-api"
import type { SupllierRequest } from "@/types/codegen/data-contracts"
import { HttpClient } from "../../../../app/api/HttpClient"

export const fetchSuppliers = async (searchTerms: Record<string, any> = {}) => {
    const params: any = {
        populate: "*",
        sort: "createdAt:desc",
        filters: {},
        pagination: {
            page: "1",
            pageSize: "10",
        },
    }

    Object.keys(searchTerms).forEach(key => {
        const value = searchTerms[key]
        if (value === undefined || value === "") return

        if (key === "page" || key === "pageSize") {
            params.pagination = {
                ...params.pagination,
                [key]: String(value),
            }
            return
        }

        if (key === "sort") {
            params.sort = String(value)
            return
        }

        params.filters[key] = { $containsi: value }
    })

    const res = await HttpClient.get(API_PREFIX_SUPPLIERS_PATH, { params ,skipDomainFilter:true})

    return {
        data: res.data,
        meta: res.meta,
    }
}

export const fetchSupplierById = async (id: number) => {
    const url = `${API_PREFIX_SUPPLIERS_PATH}/${id}`;

    const res = await HttpClient.get(url, {
        params: {
            populate: "*"
        },skipDomainFilter:true
    });

    return res.data;
}

export const createSupplier = (data: SupllierRequest) =>
    HttpClient.post(API_PREFIX_SUPPLIERS_PATH, data,{skipDomainFilter:true})

export const updateSupplierById = (id: number, data: SupllierRequest) =>
    HttpClient.put(`${API_PREFIX_SUPPLIERS_PATH}/${id}`, data,{skipDomainFilter:true})

export const deleteSupplierById = (id: number) =>
    HttpClient.delete(`${API_PREFIX_SUPPLIERS_PATH}/${id}`,{skipDomainFilter:true})

export const stores = {
    fetchSuppliers,
    fetchSupplierById,
    createSupplier,
    updateSupplierById,
    deleteSupplierById,
}
